import type { SearchResponse } from '../domain';
import { searchProperties } from '../infrastructure';

export async function fetchSearchResults(params: URLSearchParams): Promise<SearchResponse> {
  return searchProperties(params);
}
